<script>
import {HistoryMixin, orderMixin} from "@/mixin";
export default {
    name: "EmptyState",
    mixins: [HistoryMixin, orderMixin],
    data() {
        return {
            listQuery: {
                statusId: 0,
            },
        }
    },
    methods: {
        isDraftTab: function () {
            return this.listQuery.statusId === this.draftStatus;
        },
        isDeclaredTab: function () {
            return this.listQuery.statusId === this.declaredStatus;
        },
        isCanceledTab: function () {
            return this.listQuery.statusId === this.canceledStatus;
        },
        filterStatusWrap: function() {
            return this.$emit('filter-status-wrap');
        },
    }
}
</script>

<template>
    <div class="container empty-notification">
<!--        <img src="~@/assets/images/empty_img.svg" alt="">-->
        <div class="empty-notification__text">
            <p v-if="isProlongation()">Тут будуть з`являтися страховi полiси, дата закiнчення яких через 30 днiв, або ранiше.
                Оформіть страховку або змініть параметри  <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a>  замовлень.</p>
            <p v-else-if="isDraftTab()">Тут будуть з'являтися страхові поліси зі статусом чернетка. Створіть чернетку або змініть параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
            <p v-else-if="isDeclaredTab()">Тут будуть з'являтися страхові поліси зі статусом заявлений. Заявіть чернетку або змініть параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
            <p v-else-if="isCanceledTab()">Тут будуть з'являтися страхові поліси зі статусом припинений. Змінити параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
            <p v-else>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" width="30px" height="30px">
                <path d="M56.9,54.2l-9-9.1c-0.3-0.3-0.7-0.4-1.1-0.4c-0.4,0-0.8,0.1-1,0.4l-1,1.1L43.6,45c3.2-3.7,5.1-8.4,5.1-13.6	c0-11.4-9.2-20.6-20.4-20.6S7.9,20,7.9,31.4C7.9,42.8,17,52,28.3,52c5.2,0,9.9-2,13.5-5.2l1.2,1.2l-1.1,1.1c-0.6,0.6-0.6,1.6,0,2.2	l9,9.1c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.1,1-0.5l4-4C57.5,55.7,57.5,54.8,56.9,54.2z M28.3,49c-9.6,0-17.4-7.8-17.4-17.5	s7.8-17.6,17.4-17.6c9.6,0,17.4,7.9,17.4,17.6S37.9,49,28.3,49z M51.9,57.2l-6.9-7l1.9-1.9l6.9,7L51.9,57.2z"/><path d="M18.5,29.3c0.1,0,0.3,0.1,0.5,0.1c0.5,0,1-0.4,1.3-0.9c1.2-3.5,4.5-5.8,8.1-5.8c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3	c-4.8,0-9,3-10.6,7.5C17.5,28.3,17.9,29.1,18.5,29.3z"/>
                <path d="M18.9,35.3c0.7,0,1.3-0.6,1.3-1.3v-0.2c0-0.8-0.5-1.3-1.3-1.3c0,0,0,0,0,0c-0.7,0-1.3,0.5-1.3,1.3V34	C17.6,34.7,18.1,35.3,18.9,35.3z"/>
              </svg>
              <span class="empty-notification-title">Історія замовлень порожня.</span>
              <br>
              <span class="empty-notification-description">Спробуйте змінити параметри фільтра або створіть перше замовлення.</span>
<!--                <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.-->
            </p>
        </div>
        <a data-toggle="modal" data-target="#modalSearch" class="header__create">Cтворити
            страховку</a>
    </div>
</template>

<style scoped>

</style>
